import * as React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS, COLORS } from '../styles';
import { PageWidth } from '../Layouts';

const BannersWrapper = styled.div`
  background-color: ${COLORS.primary_20};
`;

const BannerContent = styled(PageWidth)`
  background-color: ${COLORS.primary_20};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${BREAKPOINTS.MEDIUM} {
    flex-direction: row;
    padding: 48px 12px;
  }

  & > *:first-child {
    padding-top: 12px;
    width: 320px;
    height: 180px;
    ${BREAKPOINTS.MEDIUM} {
      padding-top: 0;
      margin-right: 20px;
      width: 384px;
      height: 216px;
    }
  }
  & h2 {
    font-weight: bold;
    font-size: 24px;
    margin: 16px 0 24px 0;
  }
  & p {
    margin: 0;
    padding: 0 0 28px 0;
    max-width: 310px;
  }
  & div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 18px;
    ${BREAKPOINTS.MEDIUM} {
      margin-left: 20px;
      align-items: start;
      justify-content: start;
      width: 384px;
    }
  }
`;

type Props = { children: any; testId?: string };

const OverviewBanner = ({ children, testId }: Props) => {
  return (
    <BannersWrapper>
      <BannerContent data-testid={testId}>{children}</BannerContent>
    </BannersWrapper>
  );
};

export default OverviewBanner;
